import { Link } from "react-router-dom";
import { Card, CardContent } from "./ui/card";
import { Badge } from "./ui/badge";
import { Button } from "./ui/button";
import { Clock, Users, Calendar, ChevronRight } from "lucide-react";

const getLevelBadgeClass = (level) => {
  switch (level) {
    case "Base":
      return "badge-base";
    case "Intermedio":
      return "badge-intermedio";
    case "Avanzato":
      return "badge-avanzato";
    default:
      return "";
  }
};

export const CourseCard = ({ course }) => {
  const spotsLeft = course.max_participants - course.current_participants;
  const isFull = spotsLeft <= 0;

  return (
    <Card
      className="group rounded-2xl border-border/50 overflow-hidden card-hover"
      data-testid={`course-card-${course.course_id}`}
    >
      {/* Image */}
      <div className="relative h-48 overflow-hidden bg-secondary">
        <img
          src={course.image_url || "https://images.unsplash.com/photo-1737063935340-f9af0940c4c5?crop=entropy&cs=srgb&fm=jpg&q=85"}
          alt={course.title}
          className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
          onError={(e) => {
            e.target.src = "https://images.unsplash.com/photo-1737063935340-f9af0940c4c5?crop=entropy&cs=srgb&fm=jpg&q=85";
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute top-3 left-3 flex gap-2">
          <Badge className={`${getLevelBadgeClass(course.level)} border-0`}>
            {course.level}
          </Badge>
        </div>
        <div className="absolute bottom-3 left-3 right-3">
          <h3 className="font-serif text-lg font-semibold text-white line-clamp-2">
            {course.title}
          </h3>
        </div>
      </div>

      <CardContent className="p-5">
        {/* Info Grid */}
        <div className="grid grid-cols-2 gap-3 mb-4">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Clock className="w-4 h-4 text-primary" />
            <span>{course.duration}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Calendar className="w-4 h-4 text-primary" />
            <span>{new Date(course.date).toLocaleDateString("it-IT", { day: "numeric", month: "short" })}</span>
          </div>
          <div className="col-span-2 flex items-center gap-2 text-sm text-muted-foreground">
            <Users className="w-4 h-4 text-primary" />
            <span>
              {isFull ? (
                <span className="text-destructive">Corso al completo</span>
              ) : (
                `${spotsLeft} posti disponibili`
              )}
            </span>
          </div>
        </div>

        {/* Product Line Badge */}
        <Badge variant="secondary" className="mb-4 rounded-full">
          {course.product_line}
        </Badge>

        {/* Description */}
        <p className="text-sm text-muted-foreground line-clamp-2 mb-4">
          {course.description}
        </p>

        {/* Action */}
        <Link to={`/corso/${course.course_id}`}>
          <Button
            className="w-full rounded-full group/btn btn-shine"
            disabled={isFull}
            data-testid={`view-course-btn-${course.course_id}`}
          >
            {isFull ? "Corso al completo" : "Scopri di più"}
            <ChevronRight className="w-4 h-4 ml-1 transition-transform group-hover/btn:translate-x-1" />
          </Button>
        </Link>
      </CardContent>
    </Card>
  );
};
